package com.eladfinish.bible.contest.screens.mikud.ui.dialogs

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.BasicText
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.LinkAnnotation
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.screens.mikud.usecases.TAG_MIKUD
import com.eladfinish.bible.contest.screens.mikud.usecases.TAG_URL
import com.eladfinish.bible.contest.ui.common.accentColor
import com.eladfinish.bible.contest.ui.common.urlBlue
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar

@Composable
internal fun MikudLevelsContentDialog(
    text: AnnotatedString,
    onMikudLevelClick: (payload: String) -> Unit,
    onUrlClick: (url: String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val linkedText = remember(text) {
        AnnotatedString.Builder(text).apply {

            // Mikud clickable parts (accent color)
            text.getStringAnnotations(tag = TAG_MIKUD, start = 0, end = text.length)
                .forEachIndexed { index, annotation ->
                    addLink(
                        clickable = LinkAnnotation.Clickable(
                            tag = "mikud_$index",
                            linkInteractionListener = { onMikudLevelClick(annotation.item) },
                        ),
                        start = annotation.start,
                        end = annotation.end,
                    )

                    addStyle(
                        style = SpanStyle(
                            color = accentColor,
                            textDecoration = TextDecoration.Underline,
                        ),
                        start = annotation.start,
                        end = annotation.end,
                    )
                }

            // URL clickable parts (blue like regular links)
            text.getStringAnnotations(tag = TAG_URL, start = 0, end = text.length)
                .forEachIndexed { index, ann ->
                    addLink(
                        clickable = LinkAnnotation.Clickable(
                            tag = "url_$index",
                            linkInteractionListener = { onUrlClick(ann.item) },
                        ),
                        start = ann.start,
                        end = ann.end,
                    )

                    addStyle(
                        style = SpanStyle(
                            color = urlBlue,
                            textDecoration = TextDecoration.Underline,
                        ),
                        start = ann.start,
                        end = ann.end,
                    )
                }
        }.toAnnotatedString()
    }

    Column(
        modifier = modifier
            .padding(all = 16.dp)
            .heightIn(max = 400.dp)
            .verticalScrollWithScrollbar(),
    ) {
        SelectionContainer {
            BasicText(
                text = linkedText,
                style = MaterialTheme.typography.bodyLarge.copy(fontSize = 16.sp),
            )
        }
    }
}
